<template>
  <v-container>
     <div id="chart">
          <apexchart
            type="treemap"
            :options="chartOptions"
            :series="seriestemp"
          ></apexchart>
        </div>
        <!--
        <div>
          {{ this.datalist }}
        </div>
        <div>{{ this.series }}****{{ this.seriestemp }}</div>-->
  </v-container>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
import apifactorynew from "../../api";
import VueApexCharts from "vue-apexcharts";
export default defineComponent({
  setup() {},
  components: {
    apexchart: VueApexCharts,
  },

  data: () => ({
    datalist: [],
    chartOptions: {
      legend: {
        show: false,
      },
      chart: {
        height: 200,
        type: "treemap",
      },
      title: {
        text: "volume_contribution",
        align: "center",
      },
      dataLabels: {
          enabled: true,
          style: {
            fontSize: '12px',
          },
          formatter: function(text, op) {
            return [text, op.value]
          },
          offsetY: -4
        },
      plotOptions: {
        treemap: {
          distributed: true,
          enableShades: false,
        },
      },
    },
    seriestemp: [],
    series: [
      {
        data: [
          {
            x: "New Delhi",
            y: 218,
          },
          {
            x: "Kolkata",
            y: 149,
          },
          {
            x: "Mumbai",
            y: 184,
          },
          {
            x: "Ahmedabad",
            y: 55,
          },
          {
            x: "Bangaluru",
            y: 84,
          },
          {
            x: "Pune",
            y: 31,
          },
          {
            x: "Chennai",
            y: 70,
          },
          {
            x: "Jaipur",
            y: 30,
          },
          {
            x: "Surat",
            y: 44,
          },
          {
            x: "Hyderabad",
            y: 68,
          },
          {
            x: "Lucknow",
            y: 28,
          },
          {
            x: "Indore",
            y: 19,
          },
          {
            x: "Kanpur",
            y: 29,
          },
        ],
      },
    ],
  }),
  methods: {
    getnewdataapicall_roi_current() {
      var alltempdata = [];
      var tempdatalist = [];
      var tempdatalist_volume_contribution = [];
      //this.series=[]

      apifactorynew
        .get_model_outcome_str()
        .then((res) => {
          if (res.status != 200) {
            tempdatalist = null;
            // alert(this.processdataitems.length);
          } else {
            alltempdata = res.data.roi_current;

            tempdatalist = alltempdata.variable;
            tempdatalist_volume_contribution = alltempdata.volume_contribution;

            //this.datalist = tempdatalist;
            for (var k1 in tempdatalist) {
              var objnew = new Object();

              objnew.x = tempdatalist[k1];

              if (tempdatalist_volume_contribution[k1] == null) {
                objnew.y = "0";
              } else {
                objnew.y = tempdatalist_volume_contribution[k1];
              }

              this.datalist.push(objnew);
            }
            var objnewseries = new Object();
            objnewseries.data = this.datalist;
            this.seriestemp.push(objnewseries);
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
      //this.series=this.datalist;
    },

    binddata() {
      this.getnewdataapicall_roi_current();
    },
  },
  mounted() {
    this.binddata();
    // this.binddata();
  },
});
</script>
<style scoped>
.roidiv {
  border-style: solid;
  border-color: black;
  border-width: 1px;
  /*margin: 5% 5% 5% 5%;*/
  padding: 2 2 2 2%;
  text-align: center;
  vertical-align: middle;
}
.namediv {
  padding: 5 5 5 5%;
  text-align: left;
  padding-right: 2%;
}
.progressbar {
  background-color: #e40046;
  color: white;
  text-align: right;
  margin-top: 2%;
  margin-bottom: 2%;
  border-style: solid;
  border-color: black;
  border-width: 1px;
}
.progressbar-values {
  text-align: right;
  padding: 2 2 2 2%;
  font-size: 9px;

  vertical-align: middle;
}
.progressbar-text {
  text-align: left;
}
.tablecellspace {
  padding-right: 5px;
}
.tablecellheader {
  color: black;
  font-weight: bold;
  margin-bottom: 20px;
  margin-top: 10%;
  text-align: center;
  font-size: 12px;
}
</style>
